import React from 'react';
import { Tooltip } from 'antd';
import { TrendingUp, TrendingDown, Minus, TriangleAlert, Check, Ban } from 'lucide-react';
import { StatusTag } from '../../common';
import { formatMoney, priceTooltip, varianceMeta } from './productPriceExplorer.controller';

const TREND_ICON = { up: <TrendingUp />, down: <TrendingDown />, flat: <Minus /> };

/** USD amount; prices converted from Bs show a "Bs→USD" pill with the conversion details. */
export function PriceValue({ amount, row, strong = false }) {
    const content = (
        <span className={`tabular-nums ${strong ? 'font-semibold text-surface-900' : 'text-surface-700'}`}>{formatMoney(amount)}</span>
    );
    const tip = priceTooltip(row);
    if (!tip) return content;
    return (
        <Tooltip title={tip}>
            <span className="inline-flex items-center gap-1.5">
                {content}
                <StatusTag tone="warning">Bs→USD</StatusTag>
            </span>
        </Tooltip>
    );
}

/** Δ vs list price pill. */
export function VarianceBadge({ value, className = '' }) {
    const meta = varianceMeta(value);
    return (
        <StatusTag tone={meta.tone} icon={TREND_ICON[meta.trend]} className={`tabular-nums ${className}`}>
            {meta.label}
        </StatusTag>
    );
}

export function SuspectChip({ deviationPercent }) {
    const tip =
        deviationPercent != null
            ? `Desviación de ${Number(deviationPercent) > 0 ? '+' : ''}${Number(deviationPercent).toFixed(1)}% frente al patrón`
            : 'Precio fuera del rango esperado';
    return (
        <Tooltip title={tip}>
            <span>
                <StatusTag tone="warning" icon={<TriangleAlert />}>
                    Precio sospechoso
                </StatusTag>
            </span>
        </Tooltip>
    );
}

export function DecisionChip({ decision }) {
    if (decision === 'validated') {
        return (
            <StatusTag tone="success" icon={<Check />}>
                Validado
            </StatusTag>
        );
    }
    if (decision === 'excluded') {
        return (
            <StatusTag tone="neutral" icon={<Ban />}>
                Excluido
            </StatusTag>
        );
    }
    return null;
}

export function PromoTag() {
    return <StatusTag tone="violet">Promo</StatusTag>;
}
